export default "__VITE_ASSET__ba8fccc4__"